import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { RESOURCES } from '@/data/endpoints';
import { nexusColors } from '@/theme';

export function AppFooter(): JSX.Element {
  return (
    <Box component="footer" sx={{ borderTop: `1px solid ${nexusColors.line}`, mt: 10, py: 6 }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1.6fr 1fr 1fr' } }}>
          <Box>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5 }}>
              <Box component="img" src="/brand/nexus-mark.svg" alt="" sx={{ height: 22, width: 22 }} />
              <Typography sx={{ fontFamily: '"Space Grotesk", sans-serif', fontWeight: 700 }}>NexusRMM API</Typography>
            </Stack>
            <Typography variant="body2" sx={{ color: nexusColors.muted, maxWidth: 320 }}>
              Every REST resource in NexusRMM, grouped and documented from the same code that runs the product.
            </Typography>
          </Box>
          <Box>
            <Typography variant="overline" sx={{ color: nexusColors.faint }}>Resources</Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              {RESOURCES.map((r) => (
                <Link key={r.id} component={RouterLink} to={`/${r.slug}`} underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>
                  {r.name}
                </Link>
              ))}
            </Stack>
          </Box>
          <Box>
            <Typography variant="overline" sx={{ color: nexusColors.faint }}>Elsewhere</Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              <Link component={RouterLink} to="/authentication" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>Authentication</Link>
              <Link href="https://wiki.nexusrmm.ai" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>Product wiki</Link>
              <Link href="https://wiki.nexusrmm.ai/roadmap" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>Roadmap</Link>
              <Link href="https://nexusrmm.ai" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>nexusrmm.ai</Link>
            </Stack>
          </Box>
        </Box>
        <Typography variant="caption" sx={{ color: nexusColors.faint, display: 'block', mt: 5 }}>
          Endpoint examples on this site are illustrative, generated from the platform's own route source — always confirm exact response shape against a live call to your instance.
        </Typography>
      </Container>
    </Box>
  );
}
